import { DateTime } from 'luxon';
import { z } from 'zod/v4-mini';

import { FileModel, fileSchema } from '@/models/FileModel.ts';
import { cz } from '@/utils/zodUtils.ts';

type RawPrescriptionInfo = {
  birthDate?: string;
  weight?: number;
  file?: FileModel;
};

export type GeneratePrescriptionInfo = {
  birthDate: string;
  weight: number;
};

export type UploadPrescriptionFile = {
  file: FileModel;
};

export type PrescriptionInfo =
  | GeneratePrescriptionInfo
  | UploadPrescriptionFile;

const requiredBirthDateOrFile = (data: RawPrescriptionInfo) => {
  if ('file' in data && data.file?.name) {
    return true;
  }
  return !!data.birthDate;
};

const requiredWeightOrFile = (data: RawPrescriptionInfo) => {
  if ('file' in data && data.file?.name) {
    return true;
  }
  return !!data.weight;
};

export const prescriptionInfoSchema = z
  .object({
    birthDate: cz.optional(
      z.iso
        .date('form.date.invalid')
        .check(cz.validation.dateBefore(DateTime.now(), 'form.date.future')),
    ),
    weight: z.optional(
      z.coerce
        .number('form.number.invalid')
        .check(
          z.minimum(1, 'diabetesForms.minimumWeight'),
          z.maximum(1000, 'diabetesForms.maximumWeight'),
        ),
    ),
    file: z.optional(fileSchema),
  })
  .check(
    z.refine(requiredBirthDateOrFile, {
      path: ['birthDate'],
      error: 'form.required',
    }),
    z.refine(requiredWeightOrFile, {
      path: ['weight'],
      error: 'form.required',
    }),
  );
